import { z } from "zod";
import {
  DTOCreateForgeProjectMember,
  DTOForgeProjectMemberCreateResponse,
  DTOForgeProjectMembersListResponse,
  DTOUpdateForgeProjectMember,
} from "../../dto";
import { RequestExecutor } from "../../transport";

export class ForgeProjectMembersEndpoint {
  constructor(private readonly requestExecutor: RequestExecutor) {}

  list(projectId: string) {
    return this.requestExecutor.json(`/forge/projects/${projectId}/members`, DTOForgeProjectMembersListResponse, {
      method: "GET",
    });
  }

  create(projectId: string, body: DTOCreateForgeProjectMember) {
    return this.requestExecutor.json(`/forge/projects/${projectId}/members`, DTOForgeProjectMemberCreateResponse, {
      method: "POST",
      body,
    });
  }

  update(projectId: string, userId: string, body: DTOUpdateForgeProjectMember) {
    return this.requestExecutor.json(
      `/forge/projects/${projectId}/members/${userId}`,
      DTOForgeProjectMemberCreateResponse,
      {
        method: "PUT",
        body,
      }
    );
  }

  delete(projectId: string, userId: string) {
    return this.requestExecutor.json(
      `/forge/projects/${projectId}/members/${userId}`,
      z.object({ ok: z.literal(true) }),
      {
        method: "DELETE",
      }
    );
  }
}
